module.exports = __webpack_public_path__ + "img/img6.bd78d995.jpg";